
<div class="full-height full-width" *ngIf="domainEntity">
	<div class="heigth-20">
		<div class="row">
			<div class="col">
				<div class="card-title truncated-text">
					{{(domainEntity)? domainEntity.name: ''}}
				</div>
			</div>
			<div class="col text-right">
				<button
					*ngFor="let action of actions"
					[enabled-by-permission]="action.enablePermission"
					(click)="invokeAction($event, action, domainEntity)"
					[disabled]="!action.enableFunc(domainEntity)"
					class="btn-clear {{ (!action.enableFunc(domainEntity))?'element-disabled':'text-primary'}} cursor-pointer">
					<i class="{{action.icon}}" placement="top" [ngbTooltip]="action.label | translate"></i>
				</button>
			</div>
		</div>
	</div>
	<div class="heigth-80 my-content-card ">
		<div class="half-width full-height" style="background-image: url('{{imagePreview}}'); background-position: center; background-repeat: no-repeat; background-size: cover;">
			&nbsp;
		</div>
		<div class="half-width full-height truncated-text" style="padding-left: 5px; padding-right: 5px;" [innerHtml]="(domainEntity)? domainEntity.name: ''">
		</div>
	</div>
</div>
